import { Injectable } from '@angular/core';

declare var smartech: any; // declare global smartech



@Injectable({
  providedIn: 'root'
})
export class SmartechService {

  constructor() { }
  trackProductClick(brandName: string,eventType:string,timeStamp:string,custId:string,sourceScreen:string,mobile:string) {
    if (typeof smartech !== 'undefined') {
      smartech('identify', mobile);
      smartech('dispatch', brandName, {
        partnerName:brandName,
        mobile:mobile,
        eventType:eventType,
        timeStamp:timeStamp,
        custId:custId,
        sourceScreen:sourceScreen
       });
    } else {
      console.warn('Smartech SDK not loaded');
    }
  }

}
